import { render, staticRenderFns } from "./SectionMain.vue?vue&type=template&id=357f2c3d&scoped=true&"
import script from "./SectionMain.vue?vue&type=script&lang=js&"
export * from "./SectionMain.vue?vue&type=script&lang=js&"
import style0 from "./SectionMain.vue?vue&type=style&index=0&id=357f2c3d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357f2c3d",
  null
  
)

export default component.exports